import React from "react";
import { useTranslation } from "react-i18next";

import { Typography } from "../Typography/Typography";

export const NotSet = () => {
  const { t } = useTranslation();
  return <Typography color="mushroom">{t("notSet")}</Typography>;
};
